export const SIDE_NAV_WIDTH = 90;
export const TOP_NAV_HEIGHT = 64;
export const BOTTOM_NAV_HEIGHT = 58;
